import apiClient from "@/api/client";
import { saveBlobResponse } from "@/utils/download";
import type { OrderResultFile, OrderResultFilesOverview } from "../types";

export const resultFilesApi = {
  // Line items expecting files + their files + per-user capability flags for one order.
  overview: (orderId: string) =>
    apiClient
      .get<{ data: OrderResultFilesOverview }>("/orders/result-files/overview/", {
        params: { order: orderId },
      })
      .then((r) => r.data.data),

  // Contractor uploads one or more result files for a single line item.
  upload: (lineItemId: string, files: File[]) => {
    const fd = new FormData();
    fd.append("line_item", lineItemId);
    files.forEach((f) => fd.append("files", f));
    return apiClient
      .post<{ data: OrderResultFile[] }>("/orders/result-files/", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((r) => r.data.data);
  },

  accept: (id: string) =>
    apiClient
      .post<{ data: OrderResultFile }>(`/orders/result-files/${id}/accept/`)
      .then((r) => r.data.data),

  reject: (id: string, comment: string) =>
    apiClient
      .post<{ data: OrderResultFile }>(`/orders/result-files/${id}/reject/`, { comment })
      .then((r) => r.data.data),

  remove: (id: string) => apiClient.delete(`/orders/result-files/${id}/`),

  // Wszystkie pliki wynikowe zamówienia jednym ZIP-em (folder na pozycję realizacyjną) —
  // autoryzowany widok Django, więc blob leci przez klienta API i zapisujemy go lokalnie.
  downloadZip: async (orderId: string) => {
    const resp = await apiClient.get("/orders/result-files/zip/", {
      params: { order: orderId },
      responseType: "blob",
    });
    saveBlobResponse(resp, "Pliki_pozycji.zip");
  },
};
